import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/lang'
import storage from '@/storage'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showLoading: false,
    // format: {id: -1, name: ''}
    project: storage.get_project(),
    profile: storage.get_profile(),
    lang: storage.get_lang()
  },
  mutations: {
    SHOWLOADING (state) {
      state.showLoading = true
    },
    HIDELOADING (state) {
      state.showLoading = false
    },
    removeProject (state) {
      storage.remove_project()
      state.project = storage.get_project()
    },
    setProject (state, project) {
      storage.set_project(project)
      state.project = project
      // init project in dougo
      // api.dougo.initProject(project.name)
    },
    removeProfile (state) {
      storage.remove_profile()
      state.profile = storage.get_profile()
    },
    setProfile (state, profile) {
      storage.set_profile(profile)
      state.profile = profile
    },
    setLang (state, lang) {
      storage.set_lang(lang)
      state.lang = lang
      // Vue.config.lang = lang
      i18n.locale = lang
    }
  },
  actions: {
    showLoading ({ commit }) {
      commit('SHOWLOADING')
    },
    hideLoading ({ commit }) {
      commit('HIDELOADING')
    },
    setProject (state, project) {
      state.commit('SET_PROJECT', project)
    },
    removeProject (state) {
      state.commit('REMOVE_PROJECT')
    },
    setLang (state, lang) {
      state.commit('SET_LANG', lang)
    }
  },
  getters: {
    showLoading: state => state.showLoading,
    project: state => state.project,
    profile: state => state.profile,
    lang: state => state.lang
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js